import React from 'react';
import Dunut from '../custom-dunnut/Dunut';
import './audit-appointments.css'




const AuditAppointments = (props) => {
    const graphData = props.data

    const legends = [
        { label: 'Originais', value: 'O' },
        { label: 'Alterados', value: 'A' },
        { label: 'Férias', value: 'F' },
        { label: 'Atestados', value: 'A' },
        { label: 'Folga', value: 'F' },
    ]

    return (
        <div className='audit-appointments-container'>
            <span className='audit-appointments-title'>Auditoria dos Apontamentos</span>
            <div className='audit-appointments-content'>
                <div className='audit-appointments-graph-contianer'>
                    <Dunut data={graphData} />
                </div>
                <div className='audit-appointments-graph-leggends-container'>
                    {graphData.map((d, i) => {
                        return (
                            <div key={i} className='audit-appointments-graph-leggends-content'>
                                <div className='audit-appointments-graph-leggends-iten' style={{ backgroundColor: d.color }} />
                                <span>{`${d.value}% ${d.label}`}</span>

                            </div>
                        )
                    })}
                </div>

                <div className='audit-appointments-graph-journey-leggends-container'>
                    {legends.map((d, i) => {
                        return (
                            <div className='audit-appointments-graph-journey-leggends-content' key={i}>
                                <div className='audit-appointments-graph-journey-leggends-iten'>
                                    <span>{d.value}</span>
                                </div>
                                <span className='audit-appointments-graph-journey-leggends-label'>{d.label}</span>
                            </div>

                        )
                    })}
                </div>
            </div>

        </div>
    )

};

export default AuditAppointments;